export default {
    MensagensPushEnviadas: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "mensagens-push-enviadas"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/MensagensPushEnviadas.js
// module id = fywe
// module chunks = 16